<template>
  <div class="w-full px-5">
    <div class="max-w-7xl mx-auto w-full py-8 relative">
      <div
        class="hiring-compo flex justify-center m-auto items-center gap-8 py-5"
      >
        <div v-for="hiring in hiringCompo" :key="hiring">
          <div class="rounded-4xl flex justify-center m-auto items-center">
            <img
              :src="hiring.imgSrc"
              :alt="hiring.imgAlt"
              class="hiring-image"
              loading="lazy"
              decoding="async"
              defer
            />
          </div>
        </div>
      </div>
      <div
        class="prev-rank absolute bottom-0 left-24 md:top-[40%] md:-left-9 cursor-pointer"
      >
        <img
          src="../assets/icon-slider-prev.svg"
          width="40px"
          height="40px"
          alt="slider-previous"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div
        class="next-rank absolute bottom-0 right-24 md:top-[40%] md:-right-10 cursor-pointer"
      >
        <img
          src="../assets/icon-slider-next.svg"
          width="40px"
          height="40px"
          alt="slider-next"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  name: "HiringComp",
  data() {
    return {
      hiringCompo: [
        {
          imgSrc: require("../assets/hiring/EY_Logo.webp"),
          imgAlt: "EY-Logo",
        },
        {
          imgSrc: require("../assets/hiring/Facebook_Logo.webp"),
          imgAlt: "Facebook-Logo",
        },
        {
          imgSrc: require("../assets/hiring/Google_Logo.webp"),
          imgAlt: "Google_Logo",
        },
        {
          imgSrc: require("../assets/hiring/HDFC_Logo.webp"),
          imgAlt: "HDFC-Logo",
        },
        {
          imgSrc: require("../assets/hiring/Honeywell_Logo.webp"),
          imgAlt: "Honeywell-Logo",
        },
        {
          imgSrc: require("../assets/hiring/ICICI_Logo.webp"),
          imgAlt: "ICICI-Logo",
        },
      ],
    };
  },

  mounted() {
    $(".hiring-compo").slick({
      infinite: true,
      autoplay: true,
      speed: 200,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $(".prev-rank"),
      nextArrow: $(".next-rank"),
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};
</script>

<style>
.hiring-image {
  width: 190px;
  height: 60px;
  padding: 10px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  border-radius: 60px;
  aspect-ratio: 190 / 60;
  object-fit: contain; 
}
.hiring-compo {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 5px;
  width: 100%;
  box-sizing: border-box; /* Ensure padding does not affect size */
}
.hiring-compo {
  position: relative;
  width: 100%;
}
.hiring-compo img {
  transition: opacity 0.3s ease;
}

.hiring-compo img.lazyload {
  opacity: 0;
}

.hiring-compo img.lazyloaded {
  opacity: 1;
}
</style>
